import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { getUrlParam } from 'libs/helper/utils';
import React, { useEffect } from 'react';

const SaladToggleButton = ({
  defaultIndex,
  items,
  onChange,
}: {
  defaultIndex?: number;
  items: Record<string, string>[];
  onChange: (value: string) => void;
}) => {
  const [value, setValue] = React.useState(items[defaultIndex ?? 0]?.value);

  const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: string) => {
    if (newValue === null) {
      return;
    }
    setValue(newValue);
    onChange(newValue);
  };

  useEffect(() => {

    setValue(items[defaultIndex ?? 0].value);
  }, [defaultIndex, location.search]);



  return (
    <div>
      <ToggleButtonGroup
        color="primary"
        value={value}
        exclusive
        onChange={handleChange}
        aria-label="Platform"
      >
        {items.map((item) => (
          <ToggleButton value={item.value}>{item.label}</ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  );
};

export default SaladToggleButton;
